<template>
    <highcharts :options="this.getChartOptions()"></highcharts>
</template>
<script>
import ChartDataService from '../../services/ChartDataService';

export default {

    data(){
        return {
            series: [], //資料，區分出各公司男女的資料
            categories: [], //類別，列出公司名
            message:'',
        }
    },
    mounted(){
        this.retrieveChartData()
    },
    methods: { 
        retrieveChartData(){
            ChartDataService.getSexAndCompanySummaryChart()
                .then((response) =>{
                    this.message = response.message;
                    var maledatas= [] //各公司投保男性數量
                    var femaledatas= [] //各公司投保女性數量
                    var companies = []
                    Object.keys(response.result.items).forEach(function(key){
                        companies.push(key) //加入公司
                        maledatas.push(response.result.items[key][0])
                        femaledatas.push(response.result.items[key][1])
                    });
                    this.series=[
                        {
                            name: '男性',
                            data: maledatas
                        }, 
                        {
                            name: '女性',
                            data: femaledatas
                        }
                    ]
                    this.categories = companies

                    //console.log(this.series, 'this.series')
                    //console.log(this.categories, 'this.categories')
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getChartOptions(){
            return {
                chart: {
                    type: 'column',
                    height: (9 / 16 * 100) + '%'
                },
                colors:[ //柱狀圖的顏色
                    '#0080FF',
                    '#FF60AF'
                ],
                title: {
                    text: '保險公司/投保性別統計',
                    style: {
                        fontSize: "40px",
                        fontWeight: "bold",
                        textAlign: "right",
                        color: "#292929",
                        padding: "8px"
                    }
                },
                xAxis: { //X軸
                    categories: this.categories,
                    labels: { 
                        style: { 
                            fontSize:'15px' 
                        } 
                    } 
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: '保單數量',
                        style: { 
                            fontSize:'15px' 
                        } 
                    },
                    stackLabels: {
                        enabled: true
                    },
                    labels: { 
                        style: { 
                            fontSize:'15px' 
                        } 
                    } 
                },
                legend: {
                    align: 'right',
                    x: -30,
                    verticalAlign: 'top',
                    y: 5,
                    floating: true,
                    backgroundColor:'white',
                    borderColor: '#CCC',
                    borderWidth: 1,
                    shadow: false,
                    itemStyle: {
                        font: '18pt Trebuchet MS, Verdana, sans-serif',
                        color: '#A0A0A0'
                    },
                    padding: 24
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true
                        },
                        
                    }
                },
                series: this.series
            }
        }
    }
}
</script>